import * as React from 'react'
import { makeStyles, Text, useOverflowMenu } from '@fluentui/react-components'

import style from '../styles/overflow-counter'

const useStyles = makeStyles(style)

const OverflowCounter = () => {
  const { ref, overflowCount, isOverflowing } = useOverflowMenu()

  const classes = useStyles()

  if (!isOverflowing) {
    return null
  }

  return (
    <div ref={ref} style={{ width: '34px' }}>
      <Text className={classes.emailBodyPreviewText}>+{overflowCount}</Text>
    </div>
  )
}

export default OverflowCounter
